export default {
  created () {
    /* eslint-disable no-undef */
    let that = this
    if (typeof datePicker === 'undefined') {
      that.hasDatePicker = false
    } else {
      that.hasDatePicker = true
    }
    /* eslint-enable no-undef */
  },
  data () {
    return {
      hasDatePicker: false
    }
  }
}
